module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--gauge",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.innerStyles)
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12c365ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-loading-spinner/src/components/Gauge.vue
// module id = 897
// module chunks = 170